import { SET_CURRENT_LANG } from './types';

const setLang = lang => dispatch =>
  dispatch({
    type: SET_CURRENT_LANG,
    payload: lang,
  });

export { setLang as default };



// WEBPACK FOOTER //
// ./src/store/modules/langs/actions.js